<template>
    <div>
        <!-- 세부요소 유형: 고른 뒤에도 바꿀 수 있다(내용이 초기화되므로 묻는다) -->
        <div class="mb-2">
            <b-dropdown :text="type_label" variant="dark" size="sm">
                <b-dropdown-item v-for="_type in element_types" :key="_type"
                                 :active="_type === type"
                                 @click="changeType(_type)"
                >
                    {{ typeLabel(_type) }}
                </b-dropdown-item>
            </b-dropdown>
        </div>

        <div v-if="type === 'input_text'">
            <p class="mb-1 f-90 fw-500">Input text</p>
            <b-form-input class="mb-1" v-model="structure.label" placeholder="입력폼 타이틀" @update="handleChange"/>
            <b-form-input class="mb-1" v-model="structure.pre_text" placeholder="입력폼 앞쪽에 나타날 텍스트"
                          @update="handleChange"/>
            <b-form-input class="mb-1" v-model="structure.placeholder" placeholder="텍스트 입력 가이드" @update="handleChange"/>
            <b-form-input v-model="structure.after_text" placeholder="입력폼 뒤쪽에 나타날 텍스트" @update="handleChange"/>
        </div>

        <div v-else-if="type === 'input_number'" class="">
            <p class="mb-1 f-90 fw-500">Input number</p>
            <b-form-input class="mb-1" v-model="structure.label" placeholder="입력폼 타이틀" @update="handleChange"/>
            <b-form-input class="mb-1" v-model="structure.pre_text" placeholder="입력폼 앞쪽에 나타날 텍스트"
                          @update="handleChange"></b-form-input>
            <b-form-input class="mb-1" v-model="structure.placeholder" placeholder="텍스트 입력 가이드"
                          @update="handleChange"></b-form-input>
            <b-form-input v-model="structure.after_text" placeholder="입력폼 뒤쪽에 나타날 텍스트"
                          @update="handleChange"></b-form-input>
        </div>

        <div v-else-if="type === 'radio'">
            <b-table-simple>
                <b-thead>
                    <b-tr>
                        <b-th class="bgray-100"> text</b-th>
                        <b-th class="bgray-100"> value</b-th>
                        <b-th class="bgray-100"> description</b-th>
                        <b-th class="bgray-100 text-center align-middle"> 삭제</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in structure" :key="item.id">
                        <b-td>
                            <b-form-input size="sm" v-model="item.text" @update="handleChange">{{
                                    item.text
                                }}
                            </b-form-input>
                        </b-td>
                        <b-td>
                            <b-form-input size="sm" v-model="item.value" @update="handleChange">{{
                                    item.value
                                }}
                            </b-form-input>
                        </b-td>
                        <b-td>
                            <b-form-checkbox :checked="!!item.description_input_type"
                                             @change="_enabled => manageDescriptionAvailability(item, _enabled)"
                            >
                                <b-input-group>
                                    <b-form-input :readonly="!item.description_input_type"
                                                  size="sm"
                                                  placeholder="상세 내용 폼에 표시될 가이드텍스트를 입력해 주세요"
                                                  v-model="item.placeholder"
                                                  @update="handleChange"
                                    >
                                    </b-form-input>

                                    <template #append>
                                        <b-dropdown
                                            :text="item.description_input_type ? description_types[item.description_input_type] : '타입'"
                                            variant="dark" size="sm" :disabled="!item.description_input_type"
                                        >
                                            <b-dropdown-item @click="setDescriptionType(index, 'text')">텍스트
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="setDescriptionType(index, 'number')">숫자
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </template>
                                </b-input-group>
                            </b-form-checkbox>
                        </b-td>
                        <b-td>
                            <b-button @click="deleteRadioCheckboxItem(index)" class="" size="sm">
                                <fa icon="trash-alt"></fa>
                            </b-button>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <div class="text-right">
                <b-button @click="addRadioCheckboxItem()" variant="blue" size="sm">라디오 선택지 추가</b-button>
            </div>
        </div>

        <div v-else-if="type === 'checkbox'">
            <b-table-simple>
                <b-thead>
                    <b-tr>
                        <b-th class="bgray-100"> text</b-th>
                        <b-th class="bgray-100"> value</b-th>
                        <b-th class="bgray-100"> description</b-th>
                        <b-th class="bgray-100 text-center align-middle"> 삭제</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in structure" :key="item.id">
                        <b-td>
                            <b-form-input size="sm" v-model="item.text" @update="handleChange">{{
                                    item.text
                                }}
                            </b-form-input>
                        </b-td>
                        <b-td>
                            <b-form-input size="sm" v-model="item.value" @update="handleChange">{{
                                    item.value
                                }}
                            </b-form-input>
                        </b-td>
                        <b-td>
                            <b-form-checkbox :checked="!!item.description_input_type"
                                             @change="_enabled => manageDescriptionAvailability(item, _enabled)"
                            >
                                <b-input-group>
                                    <b-form-input :readonly="!item.description_input_type"
                                                  size="sm"
                                                  placeholder="상세 내용 폼에 표시될 가이드텍스트를 입력해 주세요"
                                                  v-model="item.placeholder"
                                                  @update="handleChange"
                                    >
                                    </b-form-input>

                                    <template #append>
                                        <b-dropdown
                                            :text="item.description_input_type ? description_types[item.description_input_type] : '타입'"
                                            variant="dark" size="sm" :disabled="!item.description_input_type"
                                        >
                                            <b-dropdown-item @click="setDescriptionType(index, 'text')">텍스트
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="setDescriptionType(index, 'number')">숫자
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </template>
                                </b-input-group>
                            </b-form-checkbox>
                        </b-td>
                        <b-td>
                            <b-button @click="deleteRadioCheckboxItem(index)" class="" size="sm">
                                <fa icon="trash-alt"></fa>
                            </b-button>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <div class="text-right">
                <b-button @click="addRadioCheckboxItem()" variant="blue" size="sm">체크박스 선택지 추가</b-button>
            </div>
        </div>

        <div v-else-if="type === 'table'">
            <p class="mb-2 f-90 fw-500">Table</p>

            <div class="mb-2">
                <p class="mb-2 f-85 fw-500">Table 제목</p>
                <b-form-input v-model="table_title"
                              placeholder="테이블 제목"
                              @update="handleChange"
                              class=""
                >
                    {{ table_title }}
                </b-form-input>
            </div>

            <div class="mb-2">
                table_description {{ table_description }}
                <p class="mb-2 f-85 fw-500">Table 설명</p>
                <b-form-input v-model="table_description"
                              placeholder="테이블 설명"
                              @update="handleChange"
                              class=""
                >
                    {{ table_description }}
                </b-form-input>
            </div>

            <div class="mb-2">
                <p class="mb-2 f-85 fw-500">Table Header</p>
                <b-form-input v-model="table_header"
                              lazy
                              placeholder="ex. 구분, 항목A, 항목B"
                              @update="handleChange"
                              class=""
                >
                    {{ table_header }}
                </b-form-input>
            </div>

            <p class="mb-2 f-85 fw-500">Table Body</p>
            <b-table-simple class="mb-2">
                <b-tbody>
                    <b-tr>
                        <b-th class="bgray-100"></b-th>
                        <b-th v-for="(col_item, col_idx) in table_header_col"
                              :key="`subs-${item_idx}-ele-${element_idx}-table-header-${col_idx}`"
                              class="bgray-100"
                        >
                            {{ col_item }}
                        </b-th>
                        <b-th class="bgray-100">관리</b-th>
                    </b-tr>
                    <b-tr v-for="(row_item, row_index) in structure" :key="row_item.id">
                        <b-td class="bgray-100"> {{ row_index + 1 }}</b-td>
                        <b-td v-for="(col_item, col_index) in table_header_col" :key="col_item.id">
                            <div @click.capture="editCell(row_item, col_item, row_index, col_index)">
                                <!-- {{ row_item }} -->
                                <template v-if="row_item.noteditables && row_item.noteditables.includes(col_item)">
                                    <div v-html="row_item[col_item]"/>
                                </template>
                                <template v-else-if="row_item.dropdown && row_item.dropdown[col_item]">
                                    <b-dropdown :id="`dropdown-${item_idx}-${element_idx}-${row_index}-${col_index}`"
                                                :text="row_item[col_item]"
                                                size="sm"
                                    >
                                        <b-dropdown-item v-for="drop_item in row_item.dropdown[col_item]"
                                                         :key="drop_item.id"
                                        >
                                            {{ drop_item }}
                                        </b-dropdown-item>
                                        <b-dropdown-item-button
                                            @click.capture="editCell(row_item, col_item, row_index, col_index)"
                                            style="font-size:0.8em; color:#FFFFFF; background-color:#0033FF"
                                        >
                                            수정
                                        </b-dropdown-item-button>
                                    </b-dropdown>
                                </template>
                                <template v-else-if="row_item.calculation && row_item.calculation[col_item]">
                                    <div>
                                        ( {{ row_item.calculation[col_item] }} )
                                    </div>
                                </template>
                                <template v-else>
                                    <b-form-input v-model="row_item[col_item]"
                                                  readonly size="sm"
                                                  :placeholder="typeof row_item['placeholder'] !== 'undefined' && row_item['placeholder'][col_item] ? row_item['placeholder'][col_item] : null"
                                    />
                                </template>
                            </div>
                        </b-td>
                        <b-td>
                            <b-dropdown size="sm">
                                <b-dropdown-item-button @click="addDuplicatedRow(row_item, row_index)">
                                    복제
                                </b-dropdown-item-button>
                                <b-dropdown-item-button @click="deleteRow(row_item, row_index)">
                                    삭제
                                </b-dropdown-item-button>
                            </b-dropdown>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <div class="text-right">
                <b-btn variant="info" size="sm" @click="addNewTableRow">새 행 추가</b-btn>
            </div>

        </div>


        <!-- 셀 에디터 모달 -->
        <b-modal title="테이블 셀 설정"
                 :ref="`table-cell-editor-${item_idx}-${element_idx}`"
                 :id="`table-cell-editor-${item_idx}-${element_idx}`"
                 @ok="UpdateEditedCell($event)"
                 @hidden="initHandleCellEditor"
        >

            <b-form-select v-model="option_cell_selected" class="mb-3">
                <option value="input_text">텍스트 입력 폼</option>
                <option value="dropdown">드롭다운 선택지</option>
                <option value="text">수정불가 텍스트</option>
                <option value="calculation">계산식</option>
            </b-form-select>

            <!-- 텍스트 입력 폼일 경우 -->
            <template v-if="option_cell_selected == 'input_text'">
                <div class="d-flex justify-content-between editing-dfs">
                    기본 값
                    <b-form-input placeholder="미리 입력될 기본 값을 입력해주세요"
                                  v-model="editing_table.data[table_header_col[editing_table.col_index]]"
                                  class="w-75"
                    />
                </div>
            </template>
            <template v-if="option_cell_selected == 'input_text'">
                <div class="d-flex justify-content-between editing-dfs">
                    입력 유형
                    <b-form-select v-model="editing_table.data.input_type[table_header_col[editing_table.col_index]]"
                                   class="w-75"
                                   :options="[
                            { value: 'text', text: '텍스트' },
                            { value: 'number', text: '숫자' }
                        ]"
                    />
                </div>

                <div class="d-flex justify-content-between editing-dfs">
                    가이드텍스트
                    <b-form-input placeholder="입력 가이드를 입력해주세요"
                                  v-model="editing_table.data.placeholder[table_header_col[editing_table.col_index]]"
                                  class="w-75"
                    />
                </div>
            </template>

            <!-- 드롭다운 선택지일 경우 -->
            <template v-if="option_cell_selected == 'dropdown'">
                <div class="mb-3 editing-dfs">
                    선택지
                    <b-form-input placeholder="선택지 항목을 쉼표로 구분하여 입력해주세요" v-model="dropdown"
                                  @update="updateCellDropdown(editing_table.data, table_header_col[editing_table.col_index], row_index, col_index)"
                    >
                    </b-form-input>
                </div>

                <div
                    class="d-flex justify-content-between align-items-center editing-dfs p-2 border border-color-gray-300 rounded f-90 ">
                    미선택시 기본 값:
                    <b-form-input placeholder="기본값을 입력해 주세요"
                                  v-model="editing_table.data[table_header_col[editing_table.col_index]]"
                                  class="w-75"
                    />
                </div>

            </template>

            <!-- 텍스트 선택지일 경우 -->
            <template v-if="option_cell_selected == 'text'">
                <div class="editing-dfs">
                    표시 텍스트
                    <b-form-input placeholder="셀에 직접 표시될 내용을 입력해 주세요"
                                  v-model="editing_table.data[table_header_col[editing_table.col_index]]"
                    />
                </div>
            </template>

            <!-- 계산식일 경우 -->
            <template v-if="option_cell_selected == 'calculation'">
                <div class="editing-dfs">
                    계산식
                    <b-form-input :state="calculation_status" placeholder="계산식을 입력해 주세요(ex. A1+B1)"
                                  v-model="calculation_string"
                    />
                    <small :class="calculation_status ? 'text-success' : 'text-danger'">{{ calculation_status_message }}</small>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import * as ih from '@core_utils/util'
import {nodeMeta, validateCalc} from '@core_utils/subComponent/structure-tree.js'

// '설명 입력'을 껐다 켤 때 되살릴 값. 선택지 객체에 붙여 두므로 행을 지우거나 추가해도 다른 행으로 옮겨 가지 않는다
const description_backup = new WeakMap()

export default {
    name: 'EditingDFElement',
    props: {
        item_idx: {
            type: Number
        },
        element_idx: {
            type: Number
        },
        element_item: {
            type: Object
        }
    },
    data() {
        return {
            type: '세부요소 선택',
            result: '',
            structure: [],
            table_title: '',
            table_description: '',
            table_header: '',

            element_types: ['input_text', 'input_number', 'checkbox', 'radio', 'table'],
            description_types: {
                text: '텍스트',
                number: '숫자'
            },

            option_cell_selected: '',
            // alphabet: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],

            editing_table: {
                row_index: null,
                col_index: null,
                data: null
            },

            dropdown: '',

            calculation_string: '',
            calculation_validated_str: '',
            calculation_status: null,
            calculation_status_message: '계산식을 입력해 주세요 (예: A1+B1)'
        }
    },
    watch: {
        // 계산식은 v2 편집기와 같은 검사(validateCalc)를 쓴다
        calculation_string(_formula) {
            if (_formula == null || String(_formula).trim() === '') {
                this.calculation_status = null
                this.calculation_status_message = '계산식을 입력해 주세요 (예: A1+B1)'
                this.calculation_validated_str = ''
                return
            }
            const _result = validateCalc(_formula)
            this.calculation_status = _result.ok
            this.calculation_status_message = _result.ok ? '적절한 산식입니다' : _result.msg
            this.calculation_validated_str = _result.ok ? String(_formula).trim() : ''
        }
    },
    computed: {
        type_label() {
            return this.element_types.includes(this.type) ? this.typeLabel(this.type) : '세부요소 유형 선택'
        },
        table_header_col: {
            get() {
                return ih.stringToArray(this.table_header)
            }
        }
    },
    created() {
        if (this.element_item.type) {
            this.type = this.element_item.type
        }

        this.result = this.element_item.result
        this.structure = JSON.parse(JSON.stringify(this.element_item.structure))

        if (this.type === 'table') {
            this.table_title = this.element_item.table_title
            this.table_description = this.element_item.table_description
            this.table_header = ih.arrayToString(this.element_item.table_header)
        }

    },
    methods: {
        typeLabel(_type) {
            return nodeMeta(_type).ko
        },
        async changeType(target) {
            if (target === this.type) return
            if (this.element_types.includes(this.type)) {
                const ok = await this.$showModal({
                    type: 'confirm',
                    state: 'warning',
                    title: '세부요소 유형 변경',
                    message: `세부요소를 '${this.typeLabel(this.type)}'에서 '${this.typeLabel(target)}'(으)로 바꾸면 지금 세부요소 내용이 초기화됩니다. 저장 전에는 편집을 취소하면 복구됩니다.`
                })
                if (!ok) return
            }
            this.selectType(target)
        },
        selectType(target) {
            this.structure = {}
            if (target === 'input_text' || target === 'input_number') {
                this.structure = {pre_text: '', after_text: '', placeholder: ''}
            } else if (['checkbox', 'radio'].includes(target)) {
                this.result = []
                this.structure = []
            } else if (target === 'table') {
                this.result = []
                this.structure = [{
                    '구분': '값',
                    dropdown: {},
                    placeholder: {},
                    input_type: {},
                    noteditables: [],
                    // calculation 이 빠져 있으면 저장 경로(generateSubcomponentDataBy)가 죽는다.
                    // 다른 표 기본값 3곳과 행 모양을 맞춘다.
                    calculation: {}
                }]
                this.table_header = '구분'
            }

            this.type = target
            this.handleChange()
        },
        addRadioCheckboxItem() {
            let new_radio_checkbox_item = {
                text: '',
                value: ''
            }
            this.structure.push(new_radio_checkbox_item)
            this.handleChange()
        },
        async deleteRadioCheckboxItem(index) {
            const item = this.structure[index]
            if (item.text || item.value || item.description) {
                const ok = await this.$showModal({
                    type: 'confirm',
                    state: 'warning',
                    title: '선택지 삭제',
                    message: `'${item.text || item.value || index + 1 + '번'}' 선택지를 지웁니다. 저장 전에는 편집을 취소하면 복구됩니다.`
                })
                if (!ok) return
            }
            this.structure.splice(this.structure.indexOf(item), 1)
            this.handleChange()
        },
        changeAttachmentCheckbox(item, field, value){
          this.$set(item, field, value) 
        },
        manageDescriptionAvailability(item, enabled) {
            if (enabled) {
                // 껐다 켠 경우 지웠던 값을 되살린다
                const backup = description_backup.get(item) || {}
                this.$set(item, 'description_input_type', backup.description_input_type || 'text')
                this.$set(item, 'description', backup.description || '')
                this.$set(item, 'placeholder', backup.placeholder || '')
            } else {
                description_backup.set(item, {
                    description_input_type: item.description_input_type,
                    description: item.description,
                    placeholder: item.placeholder
                })
                this.$delete(item, 'description_input_type')
                this.$delete(item, 'placeholder')
                this.$delete(item, 'description')
            }

            this.handleChange()
        },
        setDescriptionType(index, type) {
            this.$set(this.structure[index], 'description_input_type', type)
            this.handleChange()
        },
        editCell(row_item, col_item, row_index, col_index) {
            let _col_item = col_item

            if (_col_item !== this.table_header_col[col_index]) {
                _col_item = this.table_header_col[col_index]
            }

            this.option_cell_selected = 'input_text'
            let _rows = JSON.parse(JSON.stringify(row_item))
            if (_rows['dropdown'] != null && _rows.dropdown[_col_item]) {
                this.option_cell_selected = 'dropdown'
                this.dropdown = ih.arrayToString(_rows.dropdown[_col_item])
            } else if (_rows['calculation'] != null && _rows.calculation[_col_item]) {
                this.option_cell_selected = 'calculation'
                this.calculation_string = _rows.calculation[_col_item]
            } else if (_rows['noteditables'] != null && _rows.noteditables.includes(_col_item)) {
                this.option_cell_selected = 'text'
            } else if (this.option_cell_selected === 'input_text') {
                if (_rows['input_type'] == null) {
                    _rows["input_type"] = {}
                }

                // 응답자 화면은 입력 유형이 없으면 텍스트로 그린다 — 기본값을 같게 둔다(확인만 눌러도 숫자 전용으로 바뀌지 않게)
                if (_rows['input_type'][_col_item] == null) {
                    _rows["input_type"][_col_item] = 'text'
                }

                if (_rows['placeholder'] == null) {
                    _rows["placeholder"] = {}
                }
            }

            this.editing_table = {
                row_index: row_index,
                col_index: col_index,
                data: JSON.parse(JSON.stringify(_rows))
            }

            this.$nextTick(() => {
                this.$bvModal.show(`table-cell-editor-${this.item_idx}-${this.element_idx}`)
            })
        },
        initHandleCellEditor() {
            this.dropdown = []
            this.option_cell_selected = null
            this.calculation_string = null

            this.editing_table = {
                row_index: null,
                col_index: null,
                data: null
            }
        },
        UpdateEditedCell(bvModalEvt) {
            const _rows = {...this.editing_table.data}
            const col_item = this.table_header_col[this.editing_table.col_index]

            bvModalEvt.preventDefault()

            //순차적으로 판단하여 저장 전 cell 상태변경을 각 셀 데이터에 반영
            if (this.option_cell_selected === 'input_text') {
                if (_rows.dropdown) delete _rows.dropdown[col_item]
                if (_rows.calculation) delete _rows.calculation[col_item]
                if (_rows.noteditables) {
                    let idx = _rows.noteditables.findIndex(item => {
                        return item == col_item
                    })
                    if (idx > -1) _rows.noteditables.splice(idx, 1)
                }
            } else if (this.option_cell_selected === 'dropdown') {
                if (_rows.placeholder) delete _rows.placeholder[col_item]
                if (_rows.calculation) delete _rows.calculation[col_item]
                if (_rows.noteditables) {
                    let idx = _rows.noteditables.findIndex(item => {
                        return item == col_item
                    })
                    if (idx > -1) _rows.noteditables.splice(idx, 1)
                }

                if (!_rows.dropdown) _rows.dropdown = {}
                _rows.dropdown[col_item] = ih.stringToArray(this.dropdown)
            } else if (this.option_cell_selected === 'text') {
                if (_rows.placeholder) delete _rows.placeholder[col_item]
                if (_rows.dropdown) delete _rows.dropdown[col_item]
                if (_rows.calculation) delete _rows.calculation[col_item]
                if (!_rows.noteditables) _rows.noteditables = []
                _rows.noteditables.push(col_item)
            } else if (this.option_cell_selected === 'calculation') {
                if (_rows.placeholder) delete _rows.placeholder[col_item]
                if (_rows.dropdown) delete _rows.dropdown[col_item]
                if (_rows.noteditables) {
                    let idx = _rows.noteditables.findIndex(item => {
                        return item == col_item
                    })
                    if (idx > -1) _rows.noteditables.splice(idx, 1)
                }

                if (this.calculation_status !== true) {
                    return false
                }

                if (!_rows.calculation) _rows.calculation = {}

                _rows.calculation[col_item] = this.calculation_validated_str
            } else {
                console.log('열행 번호에 맞는 내용이 없음')
            }

            this.$set(this.structure, this.editing_table.row_index, _rows)
            this.handleChange()

            this.$nextTick(() => {
                this.$bvModal.hide(`table-cell-editor-${this.item_idx}-${this.element_idx}`)
            })
        },
        updateCellDropdown(row_item, col_item) {
            this.$nextTick(() => {
                if (!row_item.dropdown) row_item.dropdown = {}
                row_item.dropdown[col_item] = ih.stringToArray(this.dropdown)
                this.handleChange()
            })
        },
        addNewTableRow() {
            // calculation 이 빠지면 저장 경로(generateSubcomponentDataBy)가 죽는다(selectType 의 표 기본값과 같은 모양)
            const _new_table_row = {dropdown: {}, placeholder: {}, noteditables: [], input_type: {}, calculation: {}}
            // 열 이름은 화면의 열과 같은 값(앞뒤 공백 제거)으로 — 그래야 새 행의 칸이 열과 이어진다
            this.table_header_col.forEach(_header => {
                _new_table_row[_header] = ''
            });

            this.structure.push(_new_table_row)
            this.handleChange()
        },
        addDuplicatedRow(row_item, row_index) {
            let new_item = ih.deepCopy(row_item)
            this.structure.splice(row_index, 0, new_item)
            this.handleChange()
        },
        async deleteRow(row_item, row_index) {
            const ok = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '행 삭제',
                message: `${row_index + 1}번 행을 지웁니다. 저장 전에는 편집을 취소하면 복구됩니다.`
            })
            if (!ok) return
            this.structure.splice(this.structure.indexOf(row_item), 1)
            this.handleChange()
        },
        handleChange() {
            let new_item = {
                type: this.type,
                result: this.result,
                structure: this.structure
            }
            
            if (this.type == 'table') {
                if (this.table_title) {
                    new_item.table_title = this.table_title
                }

                if (this.table_description) {
                    new_item.table_description = this.table_description
                }

                new_item.table_header = ih.stringToArray(this.table_header)
            }

            this.$emit('change', this.item_idx, this.element_idx, new_item)
        },
    }
}
</script>
